module.exports = __webpack_public_path__ + "img/elevator_big_close.68162b19.png";